import { ProcessTypes } from "@shared/src/enums/ProcessTypes";
import { FilterHDateHourDto } from "../../base/filter/FilterHDateHourDto";
import { FilterStripDto } from "@shared/src/components/core/maintenance/filter/FilterStripDtos";
import { filter } from "rxjs-compat/operator/filter";

export class FilterLoadLogDto extends FilterHDateHourDto {

    public processType: ProcessTypes;
    public stringSearch: string;
    public filterTags: FilterStripDto;

    public slice: number;
    public initialSlice: number = 50;

    public static defaultLoadLog(processType: ProcessTypes): FilterLoadLogDto {

        let result: FilterLoadLogDto = new FilterLoadLogDto();
        result.stringSearch = "";
        result.processType = processType;
        result.slice = result.initialSlice;
        result.loadDefault();
        result.filterTags = new FilterStripDto();
        return result;
    }
 
}
